<div class="mct-flex mct-col mct-gap-27"  >
  <div class="mct-flex mct-col" [hidden]="true" >
    <label> {{ 'ecommerce.item.downloadable-web-content.access-days' | translate | ucfirst }} </label>
    <p-progressSpinner [(ngModel)]="eCommerceItem.DownloadAccessDays"></p-progressSpinner>
  </div>
  <div>
    <th>{{ 'ecommerce.item.downloadable-web-content.choose-existing-header' | translate | ucfirst }}</th>
  </div>
  <div class="mct-flex mct-row mct-justify-between mct-items-center mct-gap-27"   >
    <div class="mct-flex mct-col mct-flex-1-1-0"  >
      <label> {{ 'ecommerce.item.downloadable-web-content.existing-type' | translate | ucfirst }} </label>
      <p-select
        [style]="{ width: '100%' }"
        [(ngModel)]="webContentTypeId"
        [options]="webContentTypes"
        optionLabel="ContentType"
        optionValue="ContentTypeID"
        appendTo="body"
        (onChange)="webContentTypeChanged()"
      ></p-select>
    </div>
    <div class="mct-flex mct-col mct-flex-1-1-0"  >
      <label> {{ 'ecommerce.item.downloadable-web-content.existing-record' | translate | ucfirst }} {{ eCommerceItem.ContentId }} </label>
      <p-select
        #webContentDropdown
        [style]="{ width: '100%' }"
        [(ngModel)]="eCommerceItem.ContentId"
        [options]="webContents"
        optionLabel="ContentTitle"
        optionValue="ContentID"
        filterBy="ContentTypeID"
        filterMatchMode="equals"
        [filterValue]="webContentTypeId?.toString()"
        appendTo="body"
      ></p-select>
    </div>
  </div>
  <div>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="clear()">{{ 'common.clear' | translate | uppercase }}</button>
  </div>
  <div>
    <th>{{ 'ecommerce.item.downloadable-web-content.upload-option-header' | translate | ucfirst }}</th>
  </div>
  <div>
    <wl-ecom-web-content-edit (webContentSaved)="selectUploadedWebContent($event)"></wl-ecom-web-content-edit>
  </div>
</div>
